export default async function lazyImportRetry<T>(
  importFn: () => Promise<T>,
  moduleName = "UnknownModule",
  retries = 3,
  retryDelay = 500
): Promise<T> {
  return new Promise((resolve, reject) => {
    const attempt = (count: number) => {
      importFn()
        .then(resolve)
        .catch((error) => {
          if (count <= 0) {
            console.error(`❌ Failed to load ${moduleName}`, error);
            reject(error);
            return;
          }
          console.warn(`🔁 Retrying ${moduleName} (${retries - count + 1}/${retries})...`);
          setTimeout(() => attempt(count - 1), retryDelay);
        });
    };

    attempt(retries);
  });
}
